<div class="position-relative asociado-buscador">
    @if (seleccionado) {
        <div class="form-control selected-chip" data-testid="buscador-seleccion">
            <span>{{ nombreCompleto(seleccionado) }}@if (seleccionado.nif) { <small class="text-muted"> · {{ seleccionado.nif }}</small> }</span>
            <button type="button" class="btn btn-link btn-sm p-0" aria-label="Cambiar asociado" data-testid="buscador-quitar" (click)="quitarSeleccion()">Cambiar</button>
        </div>
    } @else {
        @if (recuperando) {
            <div class="form-control text-muted small" data-testid="buscador-recuperando">Cargando la selección…</div>
        } @else {
            <input type="text" [id]="inputId" class="form-control" [formControl]="control" [placeholder]="placeholder" autocomplete="off"
                role="combobox" aria-autocomplete="list" [attr.aria-expanded]="abierto" data-testid="buscador-input"
                (keydown.enter)="cancelar(); buscarExacto.emit()" (keydown.escape)="cerrar()" (focus)="abrir()">
            @if (errorRecuperacion) {
                <div class="small text-danger mt-1" data-testid="buscador-error-seleccion">{{ errorRecuperacion }}</div>
            }
        }
        @if (abierto) {
            <div class="list-group position-absolute w-100" style="z-index: 5; max-height: 18rem; overflow-y: auto;" role="listbox" data-testid="buscador-lista">
                @if (cargando) {
                    <div class="list-group-item small text-muted" data-testid="buscador-cargando">Buscando…</div>
                } @else if (error) {
                    <div class="list-group-item small text-danger d-flex justify-content-between align-items-center" data-testid="buscador-error">
                        <span>{{ error }}</span>
                        <button type="button" class="btn btn-link btn-sm p-0" data-testid="buscador-reintentar" (click)="reintentar()">Reintentar</button>
                    </div>
                } @else if (!resultados.length) {
                    <div class="list-group-item small text-muted" data-testid="buscador-vacio">No se han encontrado asociados.</div>
                } @else {
                    @for (a of resultados; track a.id) {
                        <button type="button" class="list-group-item list-group-item-action" role="option" data-testid="buscador-opcion" (click)="elegir(a)">
                            <span class="d-block">{{ nombreCompleto(a) }}</span>
                            @if (a.nif) { <small class="text-muted">{{ a.nif }}</small> }
                        </button>
                    }
                }
            </div>
        }
    }
</div>
